import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'
import { compose } from 'redux'
import CSSModules from 'helpers/CSSModulesUtil'

import RejectionIconButton from './RejectionIconButton'
import ApprovalIconButton from './ApprovalIconButton'

import {
  rejectStart,
  acceptStart,
} from 'containers/Approval/ApprovalDialog/actions'
import {
  approvalsSelector,
  currentApprovalSelector,
} from 'containers/Approval/ApprovalPage/selectors'

import theme from './ApproverActionBar.scss'

const mapStateToProps = state => {
  return {
    approvals: approvalsSelector(state),
    currentApproval: currentApprovalSelector(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    rejectApproval: (workflowId, approverWorkflowStateId) => (
      dispatch(rejectStart(workflowId, approverWorkflowStateId))
    ),
    acceptApproval: (workflowId, approverWorkflowStateId) => (
      dispatch(acceptStart(workflowId, approverWorkflowStateId))
    ),
  }
}

class ApproverActionBar extends Component {
  static propTypes = {
    approvals: PropTypes.array.isRequired,
    rejectApproval: PropTypes.func.isRequired,
    acceptApproval: PropTypes.func.isRequired
  }

  static defaultProps = {
    approvals: [],
  }

  onAcceptApproval = () => {
    const {
      acceptApproval
    } = this.props
    const {
      workflowId,
      id,
    } = this.props.currentApproval

    acceptApproval(workflowId, id)
  }

  onRejectApproval = () => {
    const {
      rejectApproval
    } = this.props
    const {
      workflowId,
      id,
    } = this.props.currentApproval

    rejectApproval(workflowId, id)
  }

  render() {
    return (
      <div styleName='approvalActions'>
        <ApprovalIconButton
          onClick= { this.onAcceptApproval }
        />
        <RejectionIconButton
          onClick= { this.onRejectApproval }
        />
      </div>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyles = CSSModules(theme)
const enhance = compose(
  withConnect,
  withStyles
)

export default enhance(ApproverActionBar)
